import { AxiosDeleteToken, AxiosGet, AxiosGetToken, AxiosPostToken, AxiosPutToken } from "./AxiosCall";

export const getPostApi = async ({ post_categories_id, page, limit }) => {
  try {
    let res = await AxiosGet("post", { post_categories_id, page, limit });
    return res;
  } catch (error) {
    return error;
  }
};

export const createPostApi = async ({ post_categories_id, title, content,content_json }) => {
  try {
    let res = await AxiosPostToken("post", { post_categories_id, title, content });
    return res;
  } catch (error) {
    return error;
  }
};

export const editPostApi = async ({post_id, post_categories_id, title, content,content_json }) => {
  try {
    let res = await AxiosPutToken("post", {post_id, post_categories_id, title, content });
    return res;
  } catch (error) {
    return error;
  }
};


export const getPostDetailApi = async ({ post_id }) => {
  try {
    let res = await AxiosGet("post/by", {
      post_id
    });
    return res;
  } catch (error) {
    return error;
  }
};


export const deletePostApi = async ({ post_id }) => {
  try {
    let res = await AxiosDeleteToken("post/"+post_id);
    return res;
  } catch (error) {
    return error;
  }
};